import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';


import {
  depositRequest,
  withdrawRequest
} from '@xanadu/ui-shared/modules/user/actions';

import {
  registrationRequest
} from '@xanadu/ui-shared/modules/userRegistration/actions';

import {
  loginRequest,
  logout
} from '@xanadu/ui-shared/modules/userSession/actions';

import Buttons from '../../../components/header/Buttons';

const mapDispatchToProps = {
  depositRequest,
  loginRequest,
  logout,
  registrationRequest,
  withdrawRequest,
}

function mapStateToProps(state) {
  return {
    isLoggedIn: state.getIn(['user', 'isLoggedIn']),
    languages: state.getIn(['lookups', 'languages']),
    lastLogin: state.getIn(['user', 'lastLogin']),
    oddsTypes: state.getIn(['lookups', 'oddsTypes']),
    exchangeTypes: state.getIn(['lookups', 'exchangeTypes']),
    username: state.getIn(['user', 'username'], ''),
    widthSize: state.getIn(['application', 'widthSize']),
    storedAccountID: state.getIn(['dataLayer', 'accountID'])
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Buttons));
